import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ListarCheckpointModelos = () => {
  const [modelos, setModelos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    buscarModelos();
  }, []);

  const buscarModelos = async () => {
    try {
      const response = await axios.get("/api/checkpoints_modelo/");
      setModelos(response.data);
    } catch (error) {
      console.error("Erro ao buscar modelos de checkpoint:", error);
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Modelos de Pergunta de CheckPoint</h2>

      <div className="form-actions" style={{ marginBottom: "15px" }}>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/cadastro-checkpoint-modelo")}
        >
          Cadastrar Nova Pergunta
        </button>
      </div>

      {modelos.length === 0 ? (
        <p>Nenhuma pergunta cadastrada ainda.</p>
      ) : (
        <table className="tabela" style={{ fontSize: "0.9rem" }}>
          <thead style={{ backgroundColor: "#156082", color: "white" }}>
            <tr>
              <th style={{ textAlign: "left", width: "25%" }}>Categoria</th>
              <th style={{ textAlign: "left" }}>Pergunta</th>
            </tr>
          </thead>
          <tbody>
            {modelos.map((modelo) => (
              <tr key={modelo.id}>
                <td>{modelo.categoria}</td>
                <td>{modelo.pergunta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ListarCheckpointModelos;
